import { render } from "./TheEditor.vue?vue&type=template&id=08141014&scoped=true"
import script from "./TheEditor.vue?vue&type=script&lang=js"
export * from "./TheEditor.vue?vue&type=script&lang=js"

import "./TheEditor.vue?vue&type=style&index=0&id=08141014&lang=scss&scoped=true"

import exportComponent from "/usr/local/tomcat-jenkins/data/workspace/3d-editor-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08141014"]])

export default __exports__